import { useQuery } from "@tanstack/react-query";
import { adminBillingInfoService } from "@/services/admin-billing-info.service";

export const adminBillingInfoKeys = {
  all: ["admin", "billing-info"] as const,
  list: (tenantId?: string) =>
    [...adminBillingInfoKeys.all, "list", tenantId] as const,
};

export function useAdminBillingInfoList(tenantId?: string) {
  return useQuery({
    queryKey: adminBillingInfoKeys.list(tenantId),
    queryFn: () => adminBillingInfoService.list(tenantId),
    staleTime: 30_000,
    enabled: !!tenantId,
  });
}
